import { http } from "@canvas/api";
import store from "@/store";

export interface BouncerMultiUserGetReq {
  endpoint: "bouncer.v2.users";
  userids: string[];
}

export interface BouncerMultiUserGetRes {
  count: number;
  items: Array<{
    id: string | number;
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
    display_name: string;
    type: string;
  }>;
}

export function get(
  req: BouncerMultiUserGetReq
): Promise<BouncerMultiUserGetRes> {
  const endpoint = store.state.appModule.config && store.state.appModule.config.serviceConfigMap.bouncer;
  return http
    .GET(`/${endpoint}/v2/users?filters=id:${req.userids}`)
    .then((response: BouncerMultiUserGetRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
